import {useEffect, useRef, useState} from 'react';
export function useDebouncedState<T>(initialValue: T, delay = 300) {
  const [value, setValue] = useState(initialValue);
  const [debounced, setDebounced] = useState(initialValue);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return [value, debounced, setValue] as const;
}
export function useTimeout(callback: () => void, delay: number, active = true) {
  const latest = useRef(callback);
  latest.current = callback;
  useEffect(() => {
    if (!active) return;
    const id = setTimeout(() => latest.current(), delay);
    return () => clearTimeout(id);
  }, [delay, active]);
}
export function useInterval(callback: () => void, delay: number, active = true) {
  const latest = useRef(callback);
  latest.current = callback;
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => latest.current(), delay);
    return () => clearInterval(id);
  }, [delay, active]);
}
